import { appendAPExamTemplate } from '@/functions/idp'

import RIC from './RIC_12'

export default appendAPExamTemplate({
  ...RIC,
  aimName: 'RIC+AP'
})
